import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Input from '@/app/_components/share/formInputs/Input';

export default function MobileVerify({ onSubmit, title }) {
  const formSchema = Yup.object().shape({
    mobile: Yup.string()
      .required('فیلد شماره موبایل ضروری است ')
      .matches(/^[0-9]{11}$/, '.شماره موبایل صحیح نمی باشد'),
  });
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(formSchema),
  });

  return (
    <>
      <h3 className="py-4 text-lg text-dark-gray">{title}</h3>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input
          register={register}
          errors={errors}
          name="mobile"
          label="شماره موبایل"
          required
        />
        <button
          className="w-full bg-color-primary text-white py-2 rounded-md mt-8 mb-3 flex align-center justify-center"
          type="submit"
        >
          ورود
        </button>
        <p className="text-center text-tiny text-gray-88">
          ورود شما به معنای پذیرش شرایط برقچی و قوانین حریم خصوصی است
        </p>
      </form>
    </>
  );
}
